import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Card } from '@comparethemarketau/manor-card';

// component
import { GetInTouch } from '../common/get_in_touch';
import { ProceedWithProvider } from '../common/proceed_with_provider';
import { ViewProductDetails } from '../common/view_product_details';
import { Separator } from '../common/separator';

// widget
import { ProductSummarySm } from '../widget/product_summary_sm';
import { ProductAdditional } from '../widget/product_additional';
import { ProductPriceCard } from '../widget/product_price_card';
import { ProductIncluded } from '../widget/product_included';
import { ProceedHelpText } from '../common/proceed_help_text';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        border: 'unset',
        flexDirection: 'column',
        minHeight: '35.2rem',
        padding: {
            top: '1rem',
            right: theme.spacing[12],
            left: theme.spacing[12]
        }
    },
    topContainer: {
        top: '1.5rem'
    },
    bottomContainer: {
        display: 'flex',
        flexGrow: 1
    },
    bottomLeftContainer: {
        flexGrow: '1',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingRight: '2.1rem'
    },
    bottomRightContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minWidth: '25.6rem',
        maxWidth: '25.6rem',
        paddingBottom: '0.9rem'
    },
    viewProductDetails: {
        paddingTop: theme.spacing[12],
        paddingBottom: theme.spacing[12]
    }
}));

const ProductCardSm = ({ quote, index }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <Card
            className={classNames('test-policyProductCard-sm', classes.container)}
            margin={['0', '0', '28', '0']}
            padding={['0']}
            boxShadow={false}
        >
            <div className={classNames('test-policyProductCard-top', classes.topContainer)}>
                <ProductSummarySm quote={quote} />
            </div>
            <div className={classNames('test-policyProductCard-bottom', classes.bottomContainer)}>
                <div className={classNames('test-policyProductCard-bottom-left', classes.bottomLeftContainer)}>
                    <ProductAdditional quote={quote} />
                    <ProductIncluded quote={quote} />
                    <Separator type="horizontal" insideFlexbox />
                    <ViewProductDetails quote={quote} className={classes.viewProductDetails} />
                </div>
                <div className={classNames('test-policyProductCard-bottom-right', classes.bottomRightContainer)}>
                    <ProductPriceCard quote={quote} />
                    <GetInTouch quote={quote} />
                    <ProceedWithProvider quote={quote} currentIndex={index} />
                    <ProceedHelpText />
                </div>
            </div>
        </Card>
    );
};

ProductCardSm.propTypes = {
    quote: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired

};

export { ProductCardSm };
